import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaCaretDown, FaFileInvoiceDollar, FaLightbulb, FaUsers, FaHandshake, FaBriefcase,
  FaShoppingBag, FaTshirt, FaCertificate, FaShieldAlt, FaGlobe, FaUserTie, FaBuilding,
  FaGavel, FaHome, FaIndustry, FaLeaf, FaPlane, FaTag, FaFolderOpen, FaGlobeAsia, FaBalanceScale,
  FaDollarSign, FaFileAlt, FaBlog, FaPercentage, FaMoneyBillWave, FaBars, FaTimes
} from "react-icons/fa";
import { MdWork } from "react-icons/md";
import categoryicon from "../assets/images/categoryicon.png";
import logoImg from "../assets/images/logo-120x120.png";
import SearchForm from "./SearchForm";
import trademarkIcon from "../assets/icons/trademark.png";
import tmIcon from "../assets/icons/tm.png";
import copyrightIcon from "../assets/icons/copyright.png";

const NavBar = () => {
  const location = useLocation(); // <-- For detecting route changes
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openSubMenus, setOpenSubMenus] = useState({});

  const brandColors = ["#FF0000", "#007BFF", "#28A745", "#FFA500", "#6F42C1", "#20C997"];

  // ===== Close mobile menu on navigation =====
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const linkStyle = {
    textDecoration: "none",
    color: "inherit",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontWeight: "400",
    fontSize: "16px",
    padding: "6px 10px",
    borderRadius: "4px",
    transition: "background 0.2s ease",
    whiteSpace: "nowrap"
  };

  // ====== Menu Data ======
  const menuData = [
    {
      key: "taxation",
      title: "Taxation",
      icon: <FaFileInvoiceDollar style={{ color: "#28A745" }} />,
      columns: 3,
      links: [
        { to: "/tax-identification-number-e-tin", icon: <FaCertificate />, text: "E-TIN Certificate" },
        { to: "/vat-registration-certificate-in-bangladesh", icon: <FaCertificate />, text: "BIN Registration" },
        { to: "/account-service", icon: <FaBalanceScale />, text: "Account Service" },
        { to: "/income-tax", icon: <FaUserTie />, text: "Individual Tax" },
        { to: "/vat-return-submission-bangladesh", icon: <FaPercentage />, text: "VAT Return Submission" },
        { to: "/bookkeeping-services", icon: <FaBalanceScale />, text: "Bookkeeping Service" },
        { to: "/corporate-tax", icon: <FaBuilding />, text: "Corporate Tax" },
        { to: "/vat-software", icon: <FaFolderOpen />, text: "VAT Software" },
        { to: "/hr-management-software", icon: <FaUsers />, text: "HR Management" },
        { to: "/WitholdingTaxSubmission", icon: <FaMoneyBillWave />, text: "Withholding Tax Submission" },
        { to: "/erp-software", icon: <FaFolderOpen />, text: "ERP Software" },
        { to: "/acounting-software", icon: <FaFolderOpen />, text: "Accounting Software" },
      ]
    },
    {
      key: "startup",
      title: "Startup & Licenses",
      icon: <FaBriefcase style={{ color: "#007BFF" }} />,
      columns: 3,
      links: [
        { to: "/company-formation-in-bangladesh", icon: <FaFileAlt />, text: "Company Formation" },
        { to: "/startup-packages", icon: <FaBriefcase />, text: "Startup Package" },
        { to: "/travel-agency-license", icon: <FaPlane />, text: "Travel Agency License" },
        { to: "/one-person-company-registration-bangladesh", icon: <FaUserTie />, text: "One Person Company" },
        { to: "/import-license-irc", icon: <FaShoppingBag />, text: "Import License" },
        { to: "/buying-house-licensing-in-bangladesh", icon: <FaShoppingBag />, text: "Buying House License" },
        { to: "/partnership-registration-in-bangladesh", icon: <FaHandshake />, text: "Partnership Registration" },
        { to: "/export-license-erc", icon: <FaShoppingBag />, text: "Export License" },
        { to: "/textile-dot-license", icon: <FaTshirt />, text: "Textile (DoT) License" },
        { to: "/society-registration-in-bangladesh", icon: <FaUsers />, text: "Society Registration" },
        { to: "/association-membership", icon: <FaUsers />, text: "Association Membership" },
        { to: "/epb-license", icon: <FaCertificate />, text: "EPB License" },
        { to: "/small-business-in-bangladesh", icon: <FaIndustry />, text: "Small Business" },
        { to: "/factory-license", icon: <FaIndustry />, text: "Factory License" },
        { to: "/customs-bond-license", icon: <FaTag />, text: "Custom Bond License" },
        { to: "/trade-license", icon: <FaCertificate />, text: "Trade License" },
        { to: "/fire-license", icon: <FaHome />, text: "Fire License" },
        { to: "/company-portfolio", icon: <FaFolderOpen />, text: "Company Portfolio" },
        { to: "/rjsc-return-filing", icon: <FaFolderOpen />, text: "RJSC Return Filing" },
        { to: "/bsti-permissions", icon: <FaCertificate />, text: "BSTI Permission" },
        { to: "/loan-consultancy-services", icon: <FaBalanceScale />, text: "Loan Consultancy" },
        { to: "/share-transfer", icon: <FaHandshake />, text: "Share Transfer" },
        { to: "/premises-license-in-bangladesh", icon: <FaHome />, text: "Premises License" },
        { to: "/Home-Ministry-Endorsement-bangladesh", icon: <FaCertificate />, text: "Ministry Endorsement" },
        { to: "/share-allotment", icon: <FaCertificate />, text: "Share Allotment" },
        { to: "/environment-clearance-certificate", icon: <FaLeaf />, text: "Environment Clearance" },
        { to: "/civil-litigation", icon: <FaGavel />, text: "Civil Litigation" },
        { to: "/share-transmission", icon: <FaUsers />, text: "Share Transmission" },
        { to: "/dbid-certificate-bangladesh", icon: <FaCertificate />, text: "DBID Certificate" },
        { to: "/criminal-litigation", icon: <FaShieldAlt />, text: "Criminal Litigation" },
        { to: "/court-succession-certificate", icon: <FaCertificate />, text: "Court Succession Certificate" },
        { to: "/embassy-attestation", icon: <FaCertificate />, text: "Embassy Attestation" },
      ]
    },
    {
      key: "foreign",
      title: "Foreign Entity",
      icon: <FaGlobe style={{ color: "#FF0000" }} />,
      columns: 3,
      links: [
        { to: "/foreign-company-registration-in-bangladesh", icon: <FaFileAlt />, text: "Foreign Company Registration" },
        { to: "/branch-office-registration", icon: <FaBuilding />, text: "Branch Office Registration" },
        { to: "/foreign-direct-investment", icon: <FaDollarSign />, text: "Foreign Direct Investment" },
        { to: "/bida-permission", icon: <FaCertificate />, text: "BIDA Permission" },
        { to: "/fdi-reporting-bangladesh", icon: <FaPercentage />, text: "FDI Reporting" },
        { to: "/private-investment-visa", icon: <FaUserTie />, text: "Private Investment VISA" },
        { to: "/project-profile", icon: <FaFolderOpen />, text: "Project Profile" },
        { to: "/foreign-company-registered-address", icon: <FaHome />, text: "Registered Address" },
        { to: "/work-permit-visa", icon: <MdWork />, text: "Work Permit VISA" },
        { to: "/foreign-delegates", icon: <FaUsers />, text: "Foreign Delegates" },
        { to: "/agm-high-court-permission", icon: <FaGavel />, text: "AGM High Court Permission" },
        { to: "/company-winding-up", icon: <FaGavel />, text: "Company Winding Up" },
        { to: "/company-secretarial-service", icon: <FaFileAlt />, text: "Company Secretarial Service" },
      ]
    },
    {
      key: "ip",
      title: "Intellectual Property",
      icon: <FaLightbulb style={{ color: "#FFA500" }} />,
      columns: 3,
      links: [
        { to: "/trademark-registration-in-bangladesh", icon: <img src={trademarkIcon} alt="Trademark" />, text: "Trademark Registration" },
        { to: "/trademark-class-in-bangladesh", icon: <img src={tmIcon} alt="TM" />, text: "Trademark Class" },
        { to: "/copyright-registration", icon: <img src={copyrightIcon} alt="Copyright" />, text: "Copyright" },
        { to: "/industrial-design", icon: <FaCertificate />, text: "Industrial Design" },
        { to: "/ipr-enforcement", icon: <FaShieldAlt />, text: "IPR Enforcement" },
        { to: "/btcl-dr", icon: <FaGlobeAsia />, text: "BTCL Domain Registration" },
        { to: "/counterfeit-investigation", icon: <FaShieldAlt />, text: "Counterfeit​ Investigation" },
        { to: "/web-development", icon: <FaFolderOpen />, text: "Web Development" },
        { to: "/cloud-web-hosting", icon: <FaGlobe />, text: "Web Cloud Hosting" },
        { to: "/automation-development", icon: <FaLightbulb />, text: "Automation Development" },
        { to: "/digital-business-startup", icon: <FaBriefcase />, text: "Digital Business Startup" },
      ]
    },
    {
      key: "blogs",
      title: "Blogs",
      icon: <FaBlog style={{ color: "#6F42C1" }} />,
      to: "/blogs"
    }
  ];

  // ===== Dropdown Link Creator =====
  const createDropdownLink = (to, icon, text, index) => {
    const isImage = icon?.type === "img";
    return (
      <Link
        to={to}
        style={{
          ...linkStyle,
          fontSize: "14px",
          fontWeight: "300",
          whiteSpace: "nowrap"
        }}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "18px",
            height: "18px",
            minWidth: "18px",
            marginRight: "4px"
          }}
        >
          {isImage
            ? React.cloneElement(icon, {
                style: { width: "16px", height: "16px", objectFit: "contain" }
              })
            : React.cloneElement(icon, {
                style: {
                  color: brandColors[index % brandColors.length],
                  fontSize: "16px",
                  minWidth: "16px"
                }
              })}
        </span>
        {text}
      </Link>
    );
  };

  const navStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    width: "100%",
    background: "#fff",
    color: "#333",
    padding: isMobile ? "10px 15px" : "10px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    zIndex: 1000,
    transition: "background 0.3s ease, box-shadow 0.3s ease",
    boxShadow: isScrolled ? "0 2px 8px rgba(0,0,0,0.1)" : "none",
    minHeight: isMobile ? "70px" : "100px",
    flexWrap: isMobile ? "nowrap" : "wrap",
  };

  // ===== Desktop & Mobile Menu JSX =====
  // Desktop menu remains unchanged
  const desktopMenu = (
    <ul style={{ listStyle: "none", display: "flex", margin: 0, padding: 0, alignItems: "center", fontSize: "16px" }}>
      {menuData.map((menu, idx) => {
        if (menu.links) {
          let timeout;
          return (
            <li key={menu.key} style={{ position: "relative", padding: "6px 10px", cursor: "pointer" }}>
              <div
                onMouseEnter={() => {
                  clearTimeout(timeout);
                  setOpenSubMenus(prev => ({ ...prev, [menu.key]: true }));
                }}
                onMouseLeave={() => {
                  timeout = setTimeout(() => {
                    setOpenSubMenus(prev => ({ ...prev, [menu.key]: false }));
                  }, 200);
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  {menu.icon} {menu.title} <FaCaretDown />
                </div>
                {openSubMenus[menu.key] && (
                  <div
                    style={{
                      position: "absolute",
                      top: "130%",
                      left: "0",
                      background: "#fff",
                      padding: "15px",
                      boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                      zIndex: 999,
                      display: "grid",
                      gridTemplateColumns: `repeat(${menu.columns}, auto)`,
                      gap: "8px 12px",
                      minWidth: "220px",
                      maxHeight: "70vh",
                      overflowY: "auto",
                      fontWeight: "300",
                      fontSize: "16px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {menu.links.map((link, lidx) => createDropdownLink(link.to, link.icon, link.text, lidx))}
                  </div>
                )}
              </div>
            </li>
          );
        } else {
          return (
            <li key={menu.key} style={{ padding: "6px 10px" }}>
              <Link to={menu.to} style={linkStyle}>{menu.icon} {menu.title}</Link>
            </li>
          );
        }
      })}
    </ul>
  );

  const mobileMenu = (
    <div style={{
      position: "fixed",
      top: 0,
      right: mobileMenuOpen ? "0" : "-100%",
      width: "100%",
      maxWidth: "300px",
      height: "100vh",
      background: "#fff",
      transition: "right 0.3s ease",
      zIndex: 2000,
      padding: "15px",
      overflowY: "auto",
      boxShadow: mobileMenuOpen ? "-2px 0 8px rgba(0,0,0,0.15)" : "none",
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <img src={logoImg} alt="Logo" style={{ height: "120px" }} />
        <FaTimes style={{ fontSize: "24px", cursor: "pointer", color: "#333" }} onClick={() => setMobileMenuOpen(false)} />
      </div>
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {menuData.map((menu, idx) => (
          <li key={menu.key} style={{ marginBottom: "12px", borderBottom: "1px solid #eee", paddingBottom: "12px" }}>
            {menu.links ? (
              <>
                <div
                  style={{ 
                    display: "flex", 
                    justifyContent: "space-between", 
                    alignItems: "center", 
                    cursor: "pointer",
                    padding: "8px 0",
                    fontWeight: "500",
                    fontSize: "16px"
                  }}
                  onClick={() => setOpenSubMenus(prev => ({ ...prev, [menu.key]: !prev[menu.key] }))}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>{menu.icon} {menu.title}</div>
                  <FaCaretDown style={{ transform: openSubMenus[menu.key] ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }} />
                </div>
                {openSubMenus[menu.key] && (
                  <div style={{ paddingLeft: "10px", marginTop: "10px", display: "flex", flexDirection: "column", gap: "8px" }}>
                    {menu.links.map((link, lidx) => (
                      <Link 
                        key={lidx} 
                        to={link.to} 
                        onClick={() => setMobileMenuOpen(false)}
                        style={{
                          ...linkStyle,
                          fontSize: "16px",
                          padding: "6px 0",
                          backgroundColor: "transparent"
                        }}
                      >
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "18px",
                            height: "18px",
                            minWidth: "18px",
                            marginRight: "6px"
                          }}
                        >
                          {link.icon?.type === "img"
                            ? React.cloneElement(link.icon, { style: { width: "16px", height: "16px", objectFit: "contain" } })
                            : React.cloneElement(link.icon, { style: { color: brandColors[lidx % brandColors.length], fontSize: "16px", minWidth: "16px" } })}
                        </span>
                        {link.text}
                      </Link>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <Link to={menu.to} onClick={() => setMobileMenuOpen(false)} style={{...linkStyle, fontSize: "16px", fontWeight: "500"}}>{menu.icon} {menu.title}</Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <>
      <header style={navStyle}>
        {isMobile ? (
          <div style={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "center", gap: "15px" }}>
            <Link to="/"><img src={logoImg} alt="Logo" style={{ height: "80px" }} /></Link>
            <div style={{ flexGrow: 1, maxWidth: "400px", marginBottom: "35px", marginLeft: "20px" }}>
              <SearchForm />
            </div>
            <FaBars style={{ fontSize: "26px", cursor: "pointer", zIndex: 2100 }} onClick={() => setMobileMenuOpen(true)} />
          </div>
        ) : (
          <>
            <div style={{ display: "flex", alignItems: "center", marginLeft: "60px", gap: "20px" }}>
              <Link to="/"><img src={logoImg} alt="Logo" style={{ height: "80px" }} /></Link>
            </div>
            <nav style={{ marginLeft: "80px" }}>{desktopMenu}</nav>
            <div style={{ marginLeft: "auto", marginBottom: "35px", marginRight: "70px" }}>
              <SearchForm />
            </div>
          </>
        )}
      </header>

      {mobileMenuOpen && (
        <div 
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 1999,
            display: isMobile && mobileMenuOpen ? "block" : "none"
          }}
          onClick={() => setMobileMenuOpen(false)}
        />
      )}
      {isMobile && mobileMenu}
      <div style={{ height: isMobile ? "70px" : "100px" }}></div>
    </>
  );
};

export default NavBar;